import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./style.module.css";
import QuestionTitle from "../QuestionTitle";
import TestTitleImg from "../../../../../assets/images/joftPooch/testTitleImg.png";
import MatchTestElement from "../../../../../assets/components/Match/MatchTestElement";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";
import CustomHint from "../../../../../assets/containers/CustomHint";

export default function TestQuestion() {
  const dispatch = useDispatch();
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
  const { currentQuestion, wrongAnswers, rightAnswer } = useSelector(
    ({ quiz }) => quiz
  );
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (currentQuestion) {
      let testOptions = [
        {
          option: currentQuestion.optionA,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionA") : false,
        },
        {
          option: currentQuestion.optionB,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionB") : false,
        },
        {
          option: currentQuestion.optionC,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionC") : false,
        },
        {
          option: currentQuestion.optionD,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionD") : false,
        },
      ];
      setOptions(testOptions);
    }
  }, [currentQuestion, wrongAnswers]);

  useEffect(() => {
    if (currentQuestion) {
      const allOpts = ["optionA", "optionB", "optionC", "optionD"];
      let selected = options.indexOf(
        options.find((option) => option.selected === true)
      );
      if (selected !== -1) {
        dispatch(
          setQuestionAnswer({
            questionId: currentQuestion._id,
            userOptionAnswer: allOpts[selected],
          })
        );
      } else {
        dispatch(setQuestionAnswer(null));
      }
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [options, currentQuestion]);

  const HandleSelect = (status, index) => {
    if (soudMuted) {
      TickAudio.play();
    }
    const selectedOption = status;
    const updatedOptions = [...options];
    if (selectedOption === true) {
      const selectedBefore = options.indexOf(
        options.find((option) => option.selected === true)
      );
      if (selectedBefore !== -1) {
        updatedOptions[selectedBefore].selected = false;
      }
    }
    updatedOptions[index].selected = selectedOption;
    setOptions(updatedOptions);
  };

  useEffect(() => {
    if (wrongAnswers && options.length > 0) {
      const updatedOptions = options.map((option, index) => {
        const isWrong = wrongAnswers.includes(
          `option${String.fromCharCode(65 + index)}`
        );
        return {
          ...option,
          wrong: isWrong,
          selected: isWrong ? false : option.selected,
        };
      });
      const hasChanged = !updatedOptions.every(
        (option, index) =>
          option.wrong === options[index].wrong &&
          option.selected === options[index].selected
      );

      if (hasChanged) {
        setOptions(updatedOptions);
      }
    }
  }, [wrongAnswers]);

  function getRightAnswer(rightAnswer) {
    switch (rightAnswer) {
      case "optionA":
        return "الف";
      case "optionB":
        return "ب";
      case "optionC":
        return "ج";
      case "optionD":
        return "د";
      default:
        break;
    }
  }

  return (
    <div className="w-100">
      {rightAnswer && (
        <div className="my-5">
          <CustomHint hint={`پاسخ صحیح: ${getRightAnswer(rightAnswer)}`} />
        </div>
      )}
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? `${baseURL}file/get/${currentQuestion.cover}`
                : TestTitleImg
              : TestTitleImg
            : TestTitleImg
        }
      />
      <div className={classes.optionsBody}>
        {options.map((item, index) => {
          return (
            <MatchTestElement
              text={item.option}
              selected={item.selected}
              key={index}
              handleChange={(status) => HandleSelect(status, index)}
              index={index}
              handleClick={(status) => HandleSelect(status, index)}
              type={"test"}
              wrong={item.wrong}
            />
          );
        })}
      </div>
    </div>
  );
}
